const getPcsCount = (version: Record<string, unknown> | null | undefined): number | null => {
  const raw = (version?.pcsCount ?? version?.pcs ?? null) as unknown;
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    return raw;
  }
  if (typeof raw === 'string') {
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

export default getPcsCount;
